import React from "react";

class SpinnerComponent extends React.Component {
  state = {
    loading: true,
  };
  render() {
    return (
      <div className="spinner_overlay">
        <img alt="" className="spinner" src={require("assets/images/v2/common/genie-logo.svg").default} />
      </div>
    );
  }
}

export default SpinnerComponent;
